module.exports = __webpack_public_path__ + "img/Emiliano Martinez.fbd01dce.png";